<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <mobile-module-content *ngIf="!isLoading && !is401 && !is404" title="{{ 'Evaluations'|translate }}" [mainActions]="mainActions">

        <mat-table *ngIf="dataSource.count > 0"
                   [dataSource]="dataSource">
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="cell-mobile-first">{{ 'Name' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="cell-mobile-first">
                    <div>
                        <a [routerLink]="'/' + organization.code + '/app/athletes/' + athleteUser.id + '/evaluations/' + row.id">
                           {{ row.evaluation.title }}
                        </a>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef class="cell-mobile-middle">{{ 'CreatedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="cell-mobile-middle">
                    <div>{{ row.date|appDate:'dd.MM.yy' }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef class="cell-right cell-mobile-last">{{ 'Status' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="cell-right cell-mobile-last">
                    <div>
                        <mat-chip-set>
                            <mat-chip [ngClass]="row.status === 'opened' ? 'mat-chip-accent' : ''">{{ row.status | translate }}</mat-chip>
                        </mat-chip-set>
                    </div>
                </mat-cell>
            </ng-container>
        </mat-table>

        <mat-paginator #paginator
           [class.hidden]="dataSource.count == 0"
           [pageSizeOptions]="[10]"
           hidePageSize
           showFirstLastButtons
           [pageSize]="pageSize"
           [length]="totalSize"
           [pageIndex]="currentPage"
           (page)="onPaginateChange($event)">
        </mat-paginator>

    </mobile-module-content>
</mobile-page-content>

